import { Injectable } from "@angular/core";
import {
    HttpClient,
    HttpHeaders,
    HttpParams,
    HttpResponse,
} from "@angular/common/http";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { GRUPOS_ENDPOINTS } from "../../components/mediaManager/grupos/grupos-endpoints";

import { Observable } from "rxjs";
import { SharedMapper } from "../../utils/mappers/shared/_shared.mapper";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { GrupoMapper } from "../../utils/mappers/groups/grupos.mapper";
import { Grupo } from "../../utils/types/groups/grupo.type";
import { BaseApiService } from "../shared/_base.api.service";
import { KeyValue } from "../../utils/types/shared/keyvalue.type";
import { SharedCatalogMapper } from "../shared/sharedcatalog.service";
import { BaseMapper } from "../../utils/mappers/shared/base.mapper";

import { environment as env } from "../../../environments/environment";
import { GrupoDTO } from "../../utils/types/groups/grupoDTO.type";
import { AuthenticationService } from "../security/authentication.service";

import * as _ from "lodash";
import { ObservableDataService } from "../core/observable-data.service";
import { UserSessionType } from "../../utils/types/core/models/user-session.type";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class GruposService extends BaseApiService<Grupo> {
    model = Grupo;
    mapper: GrupoMapper = new GrupoMapper();
    apiEndPoint: any = GRUPOS_ENDPOINTS;
    currentUser: UserSessionType;

    constructor(
        private ods: ObservableDataService,
        protected http: HttpClient,
        public sharedMapper: SharedMapper
    ) {
        super(http, sharedMapper);
        this.currentUser = this.ods.getLoggedUser();
    }

    getAll(filter?: FilterType): Observable<PagedApiResponse<Grupo>> {
        let params = new HttpParams();
        let headers = new HttpHeaders();

        if (filter) {
            params = params.append("limit", filter.limit.toString());
            params = params.append("offset", filter.offset.toString());
        }

        headers = headers.append("apiKey", env.apiKey);

        return this.http
            .post(
                this.apiEndPoint.list.replace(
                    "{id}",
                    this.currentUser.companyId.toString()
                ),
                null,
                { headers, params }
            )
            .pipe(
                map((res) => {
                    return this.mapper.mapPagedApiResponse(
                        res,
                        this.mapper.mapList,
                        this.model
                    );
                })
            );
    }

    getGroupByOperator(operatorId: number): Observable<Grupo[]> {
        const id = this.currentUser.companyId.toString();
        return this.http
            .get(
                this.apiEndPoint.groupsByOperator
                    .replace("{id}", id.toString())
                    .replace("{operatorId}", operatorId.toString())
            )
            .pipe(
                map((res) => {
                    return this.mapper.mapList(res, this.model);
                })
            );
    }

    delete(id: number): Observable<boolean> {
        return this.http
            .delete(this.apiEndPoint.item.replace("{id}", id.toString()), {
                observe: "response",
            })
            .pipe(
                map((res) => {
                    if (res.status === 200) {
                        return true;
                    }
                    return false;
                })
            );
    }

    create(data: GrupoDTO): Observable<boolean> {
        data.id_user = this.currentUser.id;
        data.id_company = this.currentUser.companyId;
        return this.http.post<boolean>(this.apiEndPoint.base, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    update(data: GrupoDTO): Observable<boolean> {
        return this.http.put<boolean>(this.apiEndPoint.base, data);
    }

    get(id: Number): Observable<Grupo> {
        return this.http
            .get(this.apiEndPoint.item.replace("{id}", id.toString()))
            .pipe(
                map((res) => {
                    return BaseMapper.map(res, this.model);
                })
            );
    }

    getIdNameOperatorList(companyId: Number): Observable<Array<KeyValue>> {
        const keyValueMapper = new SharedCatalogMapper();

        return this.http
            .get(this.apiEndPoint.idNames.replace("{id}", companyId.toString()))
            .pipe(
                map((res: any) => {
                    return keyValueMapper.mapList(res.rows, KeyValue);
                })
            );
    }

    getIdNameList(filter?: FilterType): Observable<PagedApiResponse<KeyValue>> {
        const keyValueMapper = new SharedCatalogMapper();

        return this.http.post(this.apiEndPoint.idNames, filter).pipe(
            map((res) => {
                return this.sharedMapper.mapPagedApiResponse<KeyValue>(
                    res,
                    keyValueMapper.mapList,
                    this.model
                );
            })
        );
    }

    getItemsIdNameList(
        vendorId: Number,
        filter?: FilterType
    ): Observable<PagedApiResponse<KeyValue>> {
        const keyValueMapper = new SharedCatalogMapper();

        return this.http
            .post(
                this.apiEndPoint.itemIdNames.replace(
                    "{id}",
                    vendorId.toString()
                ),
                filter
            )
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse<KeyValue>(
                        res,
                        keyValueMapper.mapList,
                        KeyValue
                    );
                })
            );
    }
}
